export const COMPANY_SIZE_0_20 = 'cs_0_20';
export const COMPANY_SIZE_20_99 = 'cs_20_99';
export const COMPANY_SIZE_100_499 = 'cs_100_499';
export const COMPANY_SIZE_500_999 = 'cs_500_999';
export const COMPANY_SIZE_1000_9999 = 'cs_1000_9999';
export const COMPANY_SIZE_10000 = 'cs_10000+';
export const COMPANY_SIZE_MAP: Record<string, string> = {
  [COMPANY_SIZE_0_20]: '20人以下',
  [COMPANY_SIZE_20_99]: '20-99人',
  [COMPANY_SIZE_100_499]: '100-499人',
  [COMPANY_SIZE_500_999]: '500-999人',
  [COMPANY_SIZE_1000_9999]: '1000-9999人',
  [COMPANY_SIZE_10000]: '10000人以上',
};

export const COMPANY_FINANCING_STAGE_UNFINANCED = 'cfs_unfinanced';
export const COMPANY_FINANCING_STAGE_ANGEL = 'cfs_angel';
export const COMPANY_FINANCING_STAGE_A = 'cfs_a';
export const COMPANY_FINANCING_STAGE_B = 'cfs_b';
export const COMPANY_FINANCING_STAGE_C = 'cfs_c';
export const COMPANY_FINANCING_STAGE_D = 'cfs_d+';
export const COMPANY_FINANCING_STAGE_NO_NEED = 'cfs_no_need';
export const COMPANY_FINANCING_STAGE_LISTED = 'cfs_listed';

export const COMPANY_FINANCING_STAGE_MAP: Record<string, string> = {
  [COMPANY_FINANCING_STAGE_UNFINANCED]: '未融资',
  [COMPANY_FINANCING_STAGE_ANGEL]: '天使轮',
  [COMPANY_FINANCING_STAGE_A]: 'A轮',
  [COMPANY_FINANCING_STAGE_B]: 'B轮',
  [COMPANY_FINANCING_STAGE_C]: 'C轮',
  [COMPANY_FINANCING_STAGE_D]: 'D轮及以上',
  [COMPANY_FINANCING_STAGE_NO_NEED]: '不需要融资',
  [COMPANY_FINANCING_STAGE_LISTED]: '已上市',
};

export const EDUCATION_CATEGORY_OPTIONS = [
  { label: '全日制', value: 'full-time' },
  { label: '非全日制', value: 'part-time' },
  { label: '交流/交换', value: 'exchange' },
];

export const DEGREE_TYPE_MIDDLE_SCHOOL = 'middle_school';
export const DEGREE_TYPE_MIDDLE_SPECIALIZED = 'middle_specialized';
export const DEGREE_TYPE_HIGH_SCHOOL = 'high_school';
export const DEGREE_TYPE_COLLEGE = 'college';
export const DEGREE_TYPE_BACHELOR = 'bachelor';
export const DEGREE_TYPE_MASTER = 'master';
export const DEGREE_TYPE_DOCTOR = 'doctor';
export const DEGREE_MAP: Record<string, string> = {
  [DEGREE_TYPE_MIDDLE_SCHOOL]: '初中',
  [DEGREE_TYPE_MIDDLE_SPECIALIZED]: '中专/中技',
  [DEGREE_TYPE_HIGH_SCHOOL]: '高中',
  [DEGREE_TYPE_COLLEGE]: '大专',
  [DEGREE_TYPE_BACHELOR]: '本科',
  [DEGREE_TYPE_MASTER]: '硕士',
  [DEGREE_TYPE_DOCTOR]: '博士',
};

export const AGE_MAP: Record<string, string> = {
  GENERATION_70: '70后',
  GENERATION_80: '80后',
  GENERATION_85: '85后',
  GENERATION_90: '90后',
  GENERATION_95: '95后',
  GENERATION_00: '00后',
};

export const CULTURE_PREFERENCES = {
  design_team: '设计团队',
  product_team: '产品团队',
};

import { RestTypeEnum } from '@/context/job-builder';

export const BenefitsTypeMap: Record<string, string> = {
  basic: '基础福利',
  stock_bonuses: '股票奖金类',
  allowance: '津贴类福利',
  development: '职业发展类',
  activities: '团建活动类',
  life_care: '生活关怀类',
};

export const REST_TYPE_MAP: Record<string, string> = {
  [RestTypeEnum.Double]: '周末双休',
  [RestTypeEnum.Single]: '周末单休',
  [RestTypeEnum.BigSmall]: '大小周',
  [RestTypeEnum.Shift]: '轮班制',
};

export const WORK_OVERTIME_TYPE_MAP: Record<string, string> = {
  never: '不加班',
  occasionally: '偶尔加班',
  paid: '有偿加班',
};
